// 4-column stats / social-proof band. Lifted out of the homepage so
// per-trade landing pages can show trade-flavoured stats too.
//
// Mobile: 2-col grid. md+: 4-col. Each entry is a big numeric value
// over a short caption. Background tint + top/bottom border give the
// band visual rhythm without adding another card chrome.
import * as React from "react";

export type StatsBandAccent =
  | "amber"
  | "blue"
  | "green"
  | "rose"
  | "violet"
  | "teal"
  | "orange";

export interface StatsBandStat {
  value: string;
  label: string;
}

export interface StatsBandProps {
  stats: StatsBandStat[];
  /** Tints the value text. Defaults to inheriting `text-foreground`. */
  accent?: StatsBandAccent;
  className?: string;
}

const ACCENT_VALUE: Record<StatsBandAccent, string> = {
  amber: "text-amber-700 dark:text-amber-400",
  blue: "text-blue-700 dark:text-blue-400",
  green: "text-green-700 dark:text-green-400",
  rose: "text-rose-700 dark:text-rose-400",
  violet: "text-violet-700 dark:text-violet-400",
  teal: "text-teal-700 dark:text-teal-400",
  orange: "text-orange-700 dark:text-orange-400",
};

export function StatsBand({ stats, accent, className }: StatsBandProps) {
  const valueClass = accent
    ? ACCENT_VALUE[accent]
    : "text-foreground";
  return (
    <section
      className={`py-12 border-y bg-stone-50/50 dark:bg-secondary/20 ${className ?? ""}`}
    >
      <div className="mx-auto max-w-5xl px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat) => (
            <div key={stat.value + stat.label}>
              <p className={`text-2xl md:text-3xl font-extrabold ${valueClass}`}>
                {stat.value}
              </p>
              <p className="text-xs text-muted-foreground mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
